// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__xHje5","container":"Error_container__1pjAZ","img":"Error_img__2pUJl","btn":"Error_btn__3PAJQ"};